import { FunctionComponent, MouseEvent } from "react"
import { useLocation } from "react-router-dom"
import { Column, DataColumn } from "./table"

export type TableBodyProps = {
  data: { check: boolean; usersDetails: DataColumn[] }[]
  rowClickAction?: (e: MouseEvent<HTMLTableRowElement>) => void
  onRowSelect: (index: number, shiftKey: boolean) => void
  showCheckboxColumn: boolean
  columns: Column[]
  loading: boolean
}

const TableBody: FunctionComponent<TableBodyProps> = ({
  data,
  rowClickAction,
  onRowSelect,
  showCheckboxColumn,
  columns,
  loading,
}) => {
  const location = useLocation()
  const isEmpty = data.length === 0
  const handleRowClick = (
    e: MouseEvent<HTMLTableRowElement>,
    index: number,
  ) => {
    if (showCheckboxColumn) {
      onRowSelect(index, e.shiftKey)
    } else if (rowClickAction) {
      rowClickAction(e)
    }
  }

  return (
    <tbody>
      {loading ? (
        <tr>
          <td
            colSpan={showCheckboxColumn ? columns.length + 1 : columns.length}
            className="text-center py-4 text-gray-500">
            <div className="flex justify-center">
              <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500"></div>
            </div>
          </td>
        </tr>
      ) : isEmpty ? (
        <tr>
          <td
            colSpan={showCheckboxColumn ? columns.length + 1 : columns.length}
            className="text-center py-4 text-gray-500">
            No results found
          </td>
        </tr>
      ) : (
        data.map((row, rowIndex) => (
          <tr
            id={row.usersDetails[0].id}
            role={rowClickAction ? "button" : ""}
            onClick={(e) => handleRowClick(e, rowIndex)}
            className={`${row.check ? "bg-blue-100" : rowIndex % 2 === 0 ? "bg-white" : "bg-slate-50"} hover:bg-blue-50 text-gray-700 transition-colors ${
              rowClickAction || showCheckboxColumn ? "cursor-pointer" : ""
            }`}
            key={rowIndex}>
            {showCheckboxColumn && (
              <td className="py-3 first:pl-8 px-4 last:border-none border-r border-blue-100 border-solid">
                <input
                  type="checkbox"
                  checked={row.check}
                  onChange={() => {}}
                  onClick={(e) => {
                    e.stopPropagation()
                    onRowSelect(
                      rowIndex,
                      (e as React.MouseEvent<HTMLInputElement>).shiftKey,
                    )
                  }}
                  className="relative peer w-4 h-4 shrink-0 text-blue-600 bg-white border border-gray-300 rounded-sm focus:ring-blue-500 cursor-pointer checked:bg-blue-500 checked:border-blue-500 appearance-none"
                />
                <svg
                  className="absolute w-4 h-4 -mt-5 hidden peer-checked:block pointer-events-none text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="4">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </td>
            )}
            {columns.map((col, colIndex) => {
              const dataColumn = row.usersDetails.find(d => d.name === col.name)
              return (
                <td
                  className={`first:pl-8 px-4 last:border-none border-r border-blue-100 border-solid ${col.styles || ""} ${location.pathname.includes("recruiter") ? "py-2" : "py-3"}`}
                  key={colIndex}>
                  {dataColumn?.value || ""}
                </td>
              )
            })}
          </tr>
        ))
      )}
    </tbody>
  )
}

export default TableBody
